'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "error", "inputRef", "placeholder", "styled", "use"];
import PropTypes from 'prop-types';
import { forwardRef, useContext, memo } from 'react';
import classNames from 'classnames';
import { INPUT_SIZE_OPTIONS, USE_CLASSES } from './InputConstants';
import lazyEval from '../utils/lazyEval';
import createLazyPropType from '../utils/propTypes/createLazyPropType';
import ShareInput from '../decorators/ShareInput';
import refObject from '../utils/propTypes/refObject';
import { FieldsetContext } from '../context/FieldsetContext';
import { jsx as _jsx } from "react/jsx-runtime";
const TYPES = ['text', 'email', 'number', 'password', 'search', 'url', 'tel'];
const UITextInput = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      className,
      error,
      inputRef,
      placeholder,
      styled,
      use
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    size: fieldSize
  } = useContext(FieldsetContext);
  return /*#__PURE__*/_jsx("input", Object.assign({}, rest, {
    className: classNames('form-control private-form__control', INPUT_SIZE_OPTIONS[fieldSize], className, USE_CLASSES[use], !styled && 'private-form__control--unstyled uiTextInputUnstyled', error && 'private-form__control--error'),
    placeholder: lazyEval(placeholder),
    ref: inputRef || ref
  }));
}));
UITextInput.propTypes = {
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  inputRef: refObject,
  onChange: PropTypes.func,
  placeholder: createLazyPropType(PropTypes.string),
  readOnly: PropTypes.bool,
  styled: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(TYPES),
  use: PropTypes.oneOf(Object.keys(USE_CLASSES)),
  value: PropTypes.string
};
UITextInput.defaultProps = {
  error: false,
  styled: true,
  type: 'text'
};
UITextInput.displayName = 'UITextInput';
export default ShareInput(UITextInput);